import { z } from 'zod';

export const FormationCreatedFrom = z.enum([
  'PRISMO',
  'POLE_EMPLOI',
  'ONBOARDING',
]);

export type FormationCreatedFromT = z.infer<typeof FormationCreatedFrom>;
